import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { OpsPage } from "@/features/reporting/components/ops-page";
import { resolveGrain } from "@/features/reporting/lib/datalake";
import { resolveBoundedPeriod } from "@/features/reporting/lib/period";

const layoutRoute = getRouteApi("/_authed/_dashboard/reporting");

export const Route = createFileRoute("/_authed/_dashboard/reporting/pilotage")({
  component: ReportingPilotageRoute,
});

function ReportingPilotageRoute() {
  const search = layoutRoute.useSearch();
  const period = resolveBoundedPeriod("/reporting/pilotage", search.period);

  return (
    <OpsPage
      period={period}
      grain={resolveGrain(period, search.grain)}
      filters={{ tenantId: search.tenantId, companyId: search.companyId }}
    />
  );
}
